import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CodeSvg = function CodeSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6356F6",
    d: "M20.333 2H3.667C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.557 14.134v-1.07l-3.05-1.165 3.055-1.19v-1.08l-4.435 1.74v1.045zm1.61 1.474 2.52-7.504h-.885l-2.515 7.505zm3.27-1.475 4.435-1.72v-1.045l-4.44-1.74v1.08l3.065 1.19-3.06 1.165z"
  }));
};
export var Code = function Code(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CodeSvg
  }));
};